import { render, staticRenderFns } from "./McFormSelect.vue?vue&type=template&id=37bf8f1c"
import script from "./McFormSelect.vue?vue&type=script&lang=js"
export * from "./McFormSelect.vue?vue&type=script&lang=js"
import style0 from "./McFormSelect.vue?vue&type=style&index=0&id=37bf8f1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports